module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//green_3.png?v=a64eac24";